import { getDefaultData } from './get-default-data';
import { navigation } from '@exploration/cms-constants';

const cmsData = getDefaultData();
const bankingLinks = [
  cmsData.callToAction?.[
    navigation.products_navigation_links.banking_all_banking
  ],
  cmsData.callToAction?.[
    navigation.products_navigation_links.banking_thrivent_bank
  ],
  cmsData.callToAction?.[
    navigation.products_navigation_links.banking_church_loans
  ],
].map((link) => ({
  label: link.text,
  target: link.target,
  altText: link.text,
  url: link.href,
}));
const bankingNavigationalLink = {
  label:
    cmsData.callToAction?.[
      navigation.products_navigation_links.all_products_and_services
    ].text,
  url: cmsData.callToAction?.[
    navigation.products_navigation_links.all_products_and_services
  ].href,
};

const investmentLinks = [
  cmsData.callToAction?.[
    navigation.products_navigation_links.investments_annuities
  ],
  cmsData.callToAction?.[
    navigation.products_navigation_links.investments_mutual_funds
  ],
].map((link) => ({
  label: link.text,
  target: link.target,
  altText: link.text,
  url: link.href,
}));

const insuranceLinks = [
  cmsData.callToAction?.[
    navigation.products_navigation_links.insurance_disability_insurance
  ],
  cmsData.callToAction?.[
    navigation.products_navigation_links.insurance_life_insurance
  ],
  cmsData.callToAction?.[
    navigation.products_navigation_links.insurance_long_term_care_strategy
  ],
].map((link) => ({
  label: link.text,
  target: link.target,
  altText: link.text,
  url: link.href,
}));

const promoCard = {
  title:
    cmsData?.text?.[navigation.products_promo_card.products_promo_card_title],
  description:
    cmsData?.text?.[
      navigation.products_promo_card.products_promo_card_description
    ],
  callToAction: {
    label:
      cmsData?.callToAction?.[
        navigation.products_promo_card.products_promo_card_call_to_action
      ].text,
    url: cmsData?.callToAction?.[
      navigation.products_promo_card.products_promo_card_call_to_action
    ].href,
  },
};

export const ProductLinks = {
  bankingLinks,
  bankingNavigationalLink,
  investmentLinks,
  insuranceLinks,
  promoCard,
};
